

















import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import { Tab, Tabs, Loading, List } from "vant";
import NewsItem from "@/components/NewsItem.vue";
import request from "@/api/wanzhou/index";
import native from "@/common/Native";
import { Base64 } from "js-base64";
import AppPrompt from "@/components/AppPrompt.vue";
import { ISpecialDetail, IInfoThemeDetails } from "@/api/wanzhou/types";
import { IShareConfig, IShareConfigItem } from "@/api/types";
import Openapp from "@/components/openApp.vue";
import { wxChatShare } from "@/common/wechat";
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    NewsItem,
    [Loading.name]: Loading,
    AppPrompt,
    vanList: List,
    Openapp
  }
})
export default class SpecialPage extends Base {
  private list = [
    {
      name: "22222",
      data: "原本1111"
    },
    {
      name: "0000",
      data: "原本2222"
    }
  ];
  mounted() {}

  tabChange(index: number, name: string) {
    console.log(index);
    this.list[index].data = "这是" + index;
  }
}
